export const generateBookCovers = async (
    title,
    author,
    genre,
    suggestion
) => {
    const theme = suggestion?.theme || "abstract art";
    const colors = suggestion?.colors || "dark tones, gold";
    const imageIdea = suggestion?.imageIdea || "abstract pattern";
    const activeGenre = genre || "fiction";

    // Detect if Gemini was busy or failed
    const isGeminiBusy = !suggestion || 
        !suggestion.imageIdea || 
        suggestion.imageIdea.toLowerCase().includes("busy") || 
        suggestion.imageIdea.toLowerCase().includes("unable to parse");

    if (isGeminiBusy) {
        const CLOUD_NAME = "dhiahjrkm";
        
        // Generate 3 distinct Cloudinary AI prompts
        const frontPrompts = [
            `book cover design for a ${activeGenre} book, theme: ${theme}, colors: ${colors}, visual: ${imageIdea}, pure background art, no text`,
            `minimalist abstract ${activeGenre} book cover, colors: ${colors}, creative layout, pure background art, no text`,
            `modern premium graphic ${activeGenre} book cover design, theme: ${theme}, colors: ${colors}, pure background art, no text`
        ];

        const backPrompts = [
            `matching back cover of a ${activeGenre} book, style: clean layout, colors: ${colors}, pure background art, no text`,
            `minimalist abstract back cover, colors: ${colors}, matching theme: ${theme}, pure background art, no text`,
            `textured book back cover design backdrop, colors: ${colors}, pure background art, no text`
        ];

        return {
            front: frontPrompts.map(prompt => 
                `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/w_400,h_600,c_fill/e_gen_text_to_image:prompt_${encodeURIComponent(prompt)}/cld-sample-5.jpg`
            ),
            back: backPrompts.map(prompt => 
                `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/w_400,h_600,c_fill/e_gen_text_to_image:prompt_${encodeURIComponent(prompt)}/cld-sample-5.jpg`
            )
        };
    }

    // Generate 3 distinct styles/options for front covers with strict "no text" instructions
    const frontPrompts = [
        `${activeGenre} book cover background design, theme: ${theme}, colors: ${colors}, visual idea: ${imageIdea}, premium background artwork, cinematic lighting, photorealistic, highly detailed, award winning cover art, no text, no words, no letters, no typography`,
        `minimalist ${activeGenre} book cover background design, style: elegant clean modern graphic design, theme: ${theme}, color palette: ${colors}, simple vector graphic based on ${imageIdea}, design book design awards, no text, no words, no letters, no typography`,
        `artistic fantasy ${activeGenre} oil painting book cover background, atmospheric illustration of ${imageIdea}, style: dramatic textures, color scheme: ${colors}, gorgeous masterpiece, no text, no words, no letters, no typography`
    ];

    // Generate 3 distinct matching styles/options for back covers
    const backPrompts = [
        `matching ${activeGenre} book back cover background, style: clean layout with solid textured background using color palette: ${colors}, simple framing borders, professional back template, no text, no words, no letters, no typography`,
        `minimalist abstract back cover of a ${activeGenre} book, colors: ${colors}, matching theme: ${theme}, modern clean vector background pattern, design layout, no text, no words, no letters, no typography`,
        `premium vintage textured ${activeGenre} book back cover background, style: leather and fabric texture with gold elements, colors: ${colors}, elegant layout background, no text, no words, no letters, no typography`
    ];

    return {
        front: frontPrompts.map(prompt => 
            `https://image.pollinations.ai/prompt/${encodeURIComponent(prompt)}?width=400&height=600&nologo=true&seed=${Math.floor(Math.random() * 100000)}`
        ),
        back: backPrompts.map(prompt => 
            `https://image.pollinations.ai/prompt/${encodeURIComponent(prompt)}?width=400&height=600&nologo=true&seed=${Math.floor(Math.random() * 100000)}`
        )
    };
};